const ADDRESS_QUALITY_DISTANCE = {
  CORRECT: 10,
  UNCERTAIN: 50,
}

module.exports = {
  ADDRESS_QUALITY_DISTANCE,
}
